@if (isOpen$ | async) {
  <div
    class="fixed inset-0 bg-black/50 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4 backdrop-blur-sm animate-fade-in"
    (click)="close()"
  >
    <div
      class="bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl w-full sm:max-w-lg overflow-hidden animate-slide-up-modal"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <div class="p-4 sm:p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50">
        <h3 class="text-lg sm:text-xl font-bold text-gray-800 flex items-center gap-2">
          <lucide-icon [img]="icons.MessageSquareHeart" class="w-5 h-5 text-brand"></lucide-icon>
          Share Your Feedback
        </h3>
        <button (click)="close()" class="text-gray-400 hover:text-gray-600 cursor-pointer p-1">
          <lucide-icon [img]="icons.X" class="w-5 h-5"></lucide-icon>
        </button>
      </div>

      <!-- Content -->
      <div class="p-4 sm:p-6">
        @if (isSubmitted()) {
          <!-- Success State -->
          <div class="text-center py-6 sm:py-8">
            <div class="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-green-100 text-green-600 flex items-center justify-center mx-auto mb-4">
              <svg class="w-7 h-7 sm:w-8 sm:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <h4 class="text-base sm:text-lg font-bold text-gray-800 mb-2">Thank You! 💜</h4>
            <p class="text-gray-500 text-sm sm:text-base">Your feedback helps us build a better platform for educators.</p>
          </div>
        } @else {
          <!-- Feedback Form -->
          <p class="text-sm text-gray-500 mb-4">
            Help us make JustTeach even better! Share your thoughts, suggestions, or report any issues.
          </p>

          <textarea
            [value]="feedbackText()"
            (input)="onFeedbackInput($event)"
            [disabled]="isSubmitting()"
            placeholder="Tell us what you think... What features would you love to see? Any issues you've encountered?"
            class="w-full h-28 sm:h-32 p-3 sm:p-4 border border-gray-200 rounded-xl resize-none focus:outline-none focus:ring-2 focus:ring-brand/50 focus:border-brand transition-all text-gray-700 placeholder-gray-400 disabled:bg-gray-50 disabled:cursor-not-allowed text-sm sm:text-base"
          ></textarea>

          <div class="flex justify-end mt-4 pb-safe">
            <button
              (click)="submitFeedback()"
              [disabled]="!feedbackText().trim() || isSubmitting()"
              class="flex items-center gap-2 px-4 sm:px-5 py-2.5 bg-brand hover:bg-brand-dark text-white rounded-xl font-bold text-sm transition-all shadow-md cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            >
              @if (isSubmitting()) {
                <div class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                Sending...
              } @else {
                <lucide-icon [img]="icons.Send" class="w-4 h-4"></lucide-icon>
                Send Feedback
              }
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}
